export const LOGISTICS_DASHBOARD_MODULE_ACTIONS = {
  overview: [
    { label: "Submit Quote", to: "/dashboard/logistics/rfqs", primary: true },
    { label: "View RFQs", to: "/dashboard/logistics/rfqs", primary: false },
  ],
  rfqs: [
    { label: "Submit Quote", to: "/dashboard/logistics/rfqs", primary: true },
    { label: "View RFQs", to: "/dashboard/logistics/rfqs", primary: false },
  ],
  quotations: [
    { label: "My quotations", to: "/dashboard/logistics/rfqs", primary: true },
    { label: "Submit Quote", to: "/dashboard/logistics/rfqs", primary: false },
  ],
  contracts: [
    { label: "Active contracts", to: "/dashboard/logistics/rfqs", primary: true },
    { label: "View RFQs", to: "/dashboard/logistics/rfqs", primary: false },
  ],
  deliveries: [
    { label: "Active deliveries", to: "/dashboard/logistics/rfqs", primary: true },
    { label: "View RFQs", to: "/dashboard/logistics/rfqs", primary: false },
  ],
  invoices: [
    { label: "Generate invoice", to: "/dashboard/logistics/rfqs", primary: true },
    { label: "View RFQs", to: "/dashboard/logistics/rfqs", primary: false },
  ],
  performance: [
    { label: "View RFQs", to: "/dashboard/logistics/rfqs", primary: true },
    { label: "Notifications", to: "/notifications", primary: false },
  ],
};

export function getLogisticsDashboardModuleActions(moduleKey) {
  return LOGISTICS_DASHBOARD_MODULE_ACTIONS[moduleKey] || LOGISTICS_DASHBOARD_MODULE_ACTIONS.overview;
}

export const LOGISTICS_DASHBOARD_MODULE_ROUTES = {
  overview: "/dashboard/logistics",
  rfqs: "/dashboard/logistics/module/rfqs",
  quotations: "/dashboard/logistics/module/quotations",
  contracts: "/dashboard/logistics/module/contracts",
  deliveries: "/dashboard/logistics/module/deliveries",
  invoices: "/dashboard/logistics/module/invoices",
  performance: "/dashboard/logistics/module/performance",
};
